import { render, staticRenderFns } from "./Prompt.vue?vue&type=template&id=ff3ec068"
import script from "./Prompt.vue?vue&type=script&lang=ts"
export * from "./Prompt.vue?vue&type=script&lang=ts"
import style0 from "./Prompt.vue?vue&type=style&index=0&id=ff3ec068&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports